export const blockIconsAudioandvideoSkipPrevious = (
	<span className='material-symbols-outlined'>skip_previous</span>
);
